var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorticolas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(12695 914)",
    fill: "#36364a",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12695 -914)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12694.604 912.846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3,8.5a10.661,10.661,0,0,1-.614-1.639,3.166,3.166,0,0,1,.2-.819c.2.1.512.2.614.41a12.014,12.014,0,0,1,.512,1.127c.41-.307.2-1.331,1.024-.922.2.1.2.717.2,1.229.1,0,.307-.2.512-.307.41-.2.819-.819,1.229-.2s-.307.819-.717,1.024c-.307.2-.614.41-1.024.717a9.206,9.206,0,0,1,4.609,5.018,8.364,8.364,0,0,1-.307,6.657c-1.639,3.584-5.223,5.428-9.627,5.018.2.512.41,1.024.614,1.639a2.545,2.545,0,0,1-.1.819c-.2-.2-.614-.307-.717-.512a6.467,6.467,0,0,1-.41-.922c-.307.307-.717.512-1.024.819l-.307-1.229a3.684,3.684,0,0,1-.922.512h-.819c.1-.307.1-.614.307-.819.41-.307.922-.614,1.434-.922a9.36,9.36,0,0,1-4.4-4.711,8.509,8.509,0,0,1,0-6.35C17,10.241,20.175,8.4,25.4,8.5Zm.819,1.434h-.307a8.915,8.915,0,0,0-.922,1.127,29.044,29.044,0,0,0-3.994,12.187,6.761,6.761,0,0,0,.1,1.434H21.3a18.1,18.1,0,0,0,1.229-1.741A28.127,28.127,0,0,0,26.013,12.6a24.905,24.905,0,0,0,0-2.765Zm-1.946-.1c-3.072,1.024-4.506,3.482-5.428,6.35-.922,2.765-.307,6.554,1.024,7.374a30.515,30.515,0,0,1,4.4-13.826Zm3.072.717a29.9,29.9,0,0,1-4.506,14.031c2.253-.307,4.506-2.97,5.53-6.452.717-2.56.819-5.121-1.024-7.681ZM25.194,24.784a7.754,7.754,0,0,0,5.94-5.53c.717-2.56-.1-5.838-1.741-7.066A12.123,12.123,0,0,1,25.194,24.784ZM22.019,9.524c-2.97.819-5.018,2.458-5.838,5.223a7.654,7.654,0,0,0,1.639,7.681,12.425,12.425,0,0,1,4.2-12.9Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.536,15.976C.819,15.669.307,15.26.41,14.44A1.9,1.9,0,0,1,1.639,12.8a3.145,3.145,0,0,1,2.868,0,1.8,1.8,0,0,1,.41-.512,3.333,3.333,0,0,1,3.277-1.127c1.024.307,1.331,1.127.819,2.458a5.5,5.5,0,0,1,2.97,4.3,5.561,5.561,0,0,1-.922,3.994,5.48,5.48,0,0,1-7.271,1.639,5.713,5.713,0,0,1-2.253-7.579Zm1.536-.307A4.442,4.442,0,0,0,2.56,21.2a4.485,4.485,0,0,0,5.325,1.843,4.592,4.592,0,0,0,2.97-5.121,4.332,4.332,0,0,0-3.687-3.584c-.614,2.56-2.663,2.868-4.2,1.434Zm.819-.922v.41c.512,0,.922.307,1.434.307.614-.1.819-.717.922-1.434-.819.307-1.536.512-2.253.819Zm1.741-1.639H7.783c.2,0,.41-.307.512-.41-.2-.2-.307-.512-.512-.512a2.136,2.136,0,0,0-2.151.922Zm-1.741.512a1.921,1.921,0,0,0-2.253.41c-.1.2,0,.512,0,.717.2,0,.512.1.614,0,.512-.307,1.024-.717,1.639-1.127Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.012,18.434c0-.41,0-.922.2-1.127.307-.307.717,0,.819.307a3.711,3.711,0,0,1-1.741,4.1c-.307.2-1.331.41-1.331-.2,0-.307.614-.614.819-.819A2.72,2.72,0,0,0,8.91,18.434h.1Z",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorticolas);
export default __webpack_public_path__ + "static/media/horticolas.a47510bf6431f4ea4a7561655c351a42.svg";
export { ForwardRef as ReactComponent };